export const SET_ACCESOS = "SET_ACCESOS";
